import { render } from "./ImageContent.vue?vue&type=template&id=151b7dc1&scoped=true&lang=html"
import script from "./ImageContent.vue?vue&type=script&lang=js"
export * from "./ImageContent.vue?vue&type=script&lang=js"

import "./ImageContent.vue?vue&type=style&index=0&id=151b7dc1&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-151b7dc1"

export default script